import React, { Component } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { errorToaster } from "./../../helpers/utils";
import { getCommunityEvents } from "./../../crud/user-community.crud";
import EventCard from "./EventCard";
import EventsTable from "./EventsTable";
import Loading from "./../../components/Loading";

class CommunityEvents extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: this.props.data || [],
			searchTerm: "",
			limit: this.props.limit || 8,
			offset: this.props.offset || 0,
			showMore: this.props.data.length < this.props.limit ? false : true,
			cardView: true,
			loading: false
		};
	}

	toggleView = cardView => {
		this.setState({ ...this.state, cardView });
	};

	fetchMore = async () => {
		try {
			this.setState({ ...this.state, loading: true });
			let offset = this.state.offset + this.state.limit;
			let showMore = this.state.showMore;

			let events;
			try {
				events = await getCommunityEvents(
					this.props.communityUrl,
					this.props.title.toLowerCase(),
					this.state.searchTerm,
					this.state.limit,
					offset
				);
			} catch (err) {
				if (err.response.status === 404) events = { data: [] };
				else throw new Error(err.message);
			}

			if (events.data.length < this.state.limit) showMore = false;
			else showMore = true;

			this.setState({
				...this.state,
				data: [...this.state.data, ...events.data],
				showMore,
				offset,
				loading: false
			});
		} catch (err) {
			this.setState({ ...this.state, loading: false });
			let error = err.message || "Something went wrong!";
			errorToaster(error);
		}
	};

	search = async () => {
		try {
			this.setState({ ...this.state, loading: true });
			let offset = 0;
			let showMore = this.state.showMore;

			let events;
			try {
				events = await getCommunityEvents(
					this.props.communityUrl,
					this.props.title.toLowerCase(),
					this.state.searchTerm,
					this.state.limit,
					offset
				);
			} catch (err) {
				if (err.response.status === 404) events = { data: [] };
				else throw new Error(err.message);
			}

			if (events.data.length < this.state.limit) showMore = false;
			else showMore = true;

			this.setState({
				...this.state,
				data: [...events.data],
				showMore,
				loading: false
			});
		} catch (err) {
			this.setState({ ...this.state, loading: false });
			let error = err.message || "Something went wrong!";
			errorToaster(error);
		}
	};

	render() {
		return (
			<>
				<div className="community-events-container d-flex py-4 my-3 flex-column">
					<div className="events-header row g-0 d-flex w-100">
						<div className="col-12 text-center col-md-6 text-md-start events-title mb-2">
							{this.props.title} EVENTS
						</div>
						<div className="col-12 text-center col-md-6 text-md-end actions mb-2 d-flex justify-content-md-end justify-content-center align-items-center">
							<div className="search-container">
								<input
									type="text"
									name="searchTerm"
									className="search-input"
									value={this.state.searchTerm}
									placeholder="Search"
									onChange={e => {
										this.setState(
											{
												...this.state,
												offset: -this.state.limit,
												searchTerm: e.target.value,
												data: [],
												loading: true
											},
											() => {
												setTimeout(() => this.search(), 500);
											}
										);
									}}
								/>
							</div>
							{/*<Tippy
                              content={"Card View"}
                              placement="top"
                              arrow={true}
                              className="custom-tippy"
                            >
                                <div className={`card-view view-action d-flex ${this.state.cardView ? 'view-active' : ''}`} onClick={() => this.toggleView(true)}>
                                    <i className="fas fa-th" width={30} height={30}/>
                                </div>
                            </Tippy>
                            <Tippy
                              content={"List View"}
                              placement="top"
                              arrow={true}
                              className="custom-tippy"
                            >
                                <div className={`list-view view-action d-flex ${!this.state.cardView ? 'view-active' : ''}`} onClick={() => this.toggleView(false)}>
                                    <i className="fas fa-list" width={30} height={30}/>
                                </div>
                            </Tippy>*/}
						</div>
					</div>
					<div className="events-list row g-0">
						{this.state.cardView &&
							this.state.data.map((event, index) => (
								<div
									className="event-card p-3"
									style={{ minHeight: "180px" }}
									key={index}
								>
									<EventCard data={event} />
								</div>
							))}
						{!this.state.cardView && (
							<div className="col-12">
								<EventsTable data={this.state.data} />
							</div>
						)}
					</div>
					{this.state.loading && (
						<div className="no-more-events text-center p-5 m-5">
							<Loading className="w-100 text-center p-5" />
						</div>
					)}
					{!this.state.data.length && !this.state.loading && (
						<div className="no-more-events text-center p-5 m-5">
							<h3>There are no events to show!</h3>
						</div>
					)}
					{this.state.showMore && (
						<div className="show-more-events text-center mt-4">
							<button
								className="btn btn-dark btn-sm"
								onClick={this.fetchMore}
								disabled={this.state.loading}
							>
								Show More <i className="fas fa-angle-down" />
							</button>
						</div>
					)}
				</div>
				<style jsx>{`
					.community-events-container .events-title {
						font-size: 25px;
						font-weight: 700;
						line-height: 130%;
					}

					.community-events-container .search-input {
						border-radius: 5px;
						border: 0.8px solid #cacaca;
						padding: 7px 10px;
						margin: 0 6px;
					}

					.community-events-container .view-action i {
						color: #858585;
						font-size: 20px;
						padding: 3px;
						margin: 0 6px;
						cursor: pointer;
					}

					.community-events-container .view-active i {
						color: #572148;
						font-weight: bold;
					}
					.event-card {
						flex: 0 0 auto;
						width: 16.66%;
						display: flex;
						justify-content: center;
						margin-bottom: 30px;
					}
					@media screen and (max-width: 1860px) {
						.event-card {
							width: 20%;
						}
					}
					@media screen and (max-width: 1570px) {
						.event-card {
							width: 25%;
						}
					}
					@media screen and (max-width: 1260px) {
						.event-card {
							width: 33.33%;
						}
					}
					@media screen and (max-width: 1020px) {
						.event-card {
							width: 50%;
						}
					}
					@media screen and (max-width: 640px) {
						.event-card {
							width: 100%;
						}
					}
				`}</style>
			</>
		);
	}
}

export default CommunityEvents;
